import AuthServices from './authActions';
import BalanceServices from './balanceActions';
import UserServlet from './userServlet';
import ContactServlet from './contactServlet';
import RepliesServlet from './repliesServletActions';
import Servlet from './servletActions';
// import Inbox from './inboxActions';
import OthersAction from './othersActions';
import ManagerAction from './usersManagerActions';
import DialogAction from './dialogsActions';
import StatsAction from './statsActions';
import DidsAction from './didsActions';
import PaymentAction from './paymentAction';
import DomainAction from './domainActions';
import FilterAction from './filterActions';
import CreativeActions from './creativeActions';
import StateComponentAction from './componentActions';
import OfferActions from './offerActions';
import GuidelineActions from './guidelineActions';
import NotificationActions from './notificationActions';
import PremiumOrderActions from './premiumOrderActions';
import ProcessActions from './processActions';

export default {
  ...ProcessActions,
  ...PremiumOrderActions,
  ...GuidelineActions,
  ...NotificationActions,
  ...OfferActions,
  ...CreativeActions,
  ...FilterAction,
  ...DomainAction,
  ...PaymentAction,
  ...DidsAction,
  ...StatsAction,
  ...AuthServices,
  ...BalanceServices,
  ...ContactServlet,
  ...UserServlet,
  ...RepliesServlet,
  ...Servlet,
  // ...Inbox,
  ...OthersAction,
  ...ManagerAction,
  ...DialogAction,
  ...StateComponentAction,
};
